/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

/**
 * Sticky header
 */
var header = document.getElementById('masthead');

if (header) {
  var headroom_args = [];
  if (header.classList.contains('has-sub-header')) {
    headroom_args = {
      offset: 0,
      tolerance: 0,
      classes: {
        initial: "has-sub-header--animated",
        pinned: "has-sub-header--pinned",
        unpinned: "has-sub-header--unpinned"
      }
    };
  } else {
    headroom_args = {
      offset: 0,
      tolerance: 0,
      classes: {
        initial: "animated",
        pinned: "slideDown",
        unpinned: "slideUp"
      }
    };
  }

  var headroom = new Headroom(header, headroom_args);
  headroom.init();
}